import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import ProductModel from "../../models/products/product-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.PRODUCT) +"/api/Product/GetAllProduct";
export const useGetProducts = createQuery<
  ProductModel[],
  null,
  AxiosError
>({
  queryKey: ["keyProductlist"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    
  // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});


const Producturl = getEndPoint(API_END_POINT.ORDER) +"/api/EmployeeFreeMilk/GetAllProduct";
export const useGetAllProducts = createQuery<
  ProductModel[],
  null,
  AxiosError
>({
  queryKey: ["keyFreeMilkProductlist"],
  fetcher: (params) =>
    getDataWithToken<any>(Producturl).then((response) => response.data?.result || console.log(response)),
  //axios.get(Producturl, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});